export const buildBundle = {
  headerSteps: '{{step}} of 2',
  headerStepsFlavor: '{{step}} of 3',
  firstStep: {
    price: 'Starting at'
  },
  pricePerServingText: {
    mobile: '/ serving',
    desktop: 'per serving'
  }
};
